module.exports = __webpack_public_path__ + "static/media/logo3jpg.0404b923.jp2";